import { render, staticRenderFns } from "./PurchasingInTransit.vue?vue&type=template&id=7262c770&"
import script from "./PurchasingInTransit.vue?vue&type=script&lang=js&"
export * from "./PurchasingInTransit.vue?vue&type=script&lang=js&"
import style0 from "./PurchasingInTransit.vue?vue&type=style&index=0&id=7262c770&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports